<template>
	<!-- <div>banner</div> -->
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click='delAll'>批量删除</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%" border @selection-change="handleSelectionChange">
				<el-table-column fixed="left" type="selection" width="35">
				</el-table-column>
				<el-table-column prop="url" label="路径"  align="center">					
				</el-table-column>
				<el-table-column prop="sort" label="排序" align="center" width="100"></el-table-column>
				<el-table-column fixed="right" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="排序" label-width='100px'>
					<el-input v-model="form.sort" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="上传视频" label-width='100px'>
					<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
						:show-file-list="false" :on-success="handleAvatarSuccess">
						<img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectTableData: [],
				tableData: [{
						id: 1,
						url: "https://img0.baidu.com/it/u=103721101,4076571305&fm=26&fmt=auto&gp=0.jpg",
						sort: 1
					},
					{
						id: 2,
						url: "https://img0.baidu.com/it/u=103721101,4076571305&fm=26&fmt=auto&gp=0.jpg",
						sort: 2
					}
				],
				dialogVisible: false,
				isAdd: true,
				form: {
					imageUrl: "",
					sort: ""
				},

			}
		},
		methods: {
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
			},
			//批量删除
			delAll() {
				var ids = []

				if (this.selectTableData.length == 0) {
					this.$message('请选择需要删除项');
					return false
				}
				for (var i = 0; i < this.selectTableData.length; i++) {
					ids.push(this.selectTableData[i].id)
				}
				console.log(ids)
			},
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
			},
			//勾选数据
			handleSelectionChange(arr) {
				this.selectTableData = arr
			},
			handleAvatarSuccess(res, file) {
				this.form.imageUrl = URL.createObjectURL(file.raw);
			},
		},


	}
</script>
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px solid #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;		
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
